import { showMessage } from '../components/Toast/Store';
import { AppThunk } from '../store/reducers';
import { normalizeToastMessage } from './toastMessage';

export function toastFunction(msgType: string, msg: any, msgKey: string): AppThunk {
	return (dispatch) => {
		dispatch(
			showMessage({
				isMessage: true,
				messageType: msgType,
				messageContent: {
					0: { message: normalizeToastMessage(msg), key: msgKey },
				},
			}),
		);
	};
}
